/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CursorPaginatedResponseSupplierIntegrationQueryV1 } from '../models/cursor-paginated-response-supplier-integration-query-v-1';
import { CursorPaginationRequest } from '../models/cursor-pagination-request';
import { SupplierCreateCommandV1 } from '../models/supplier-create-command-v-1';
import { SupplierIntegrationQueryV1 } from '../models/supplier-integration-query-v-1';
import { SupplierNumberCommandV1 } from '../models/supplier-number-command-v-1';


/**
 * API for supplier integration operations
 */
@Injectable({
  providedIn: 'root',
})
export class V1SupplierIntegrationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createSupplierV1Integration
   */
  static readonly CreateSupplierV1IntegrationPath = '/v1/integration/suppliers';

  /**
   * Create a new supplier without a request.
   *
   * Creates a new supplier directly without an associated supplier request. Returns 409 if a supplier with the same email already exists.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSupplierV1Integration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSupplierV1Integration$Response(params: {

    /**
     * Supplier data to create
     */
    body: SupplierCreateCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SupplierIntegrationQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, V1SupplierIntegrationService.CreateSupplierV1IntegrationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SupplierIntegrationQueryV1>;
      })
    );
  }

  /**
   * Create a new supplier without a request.
   *
   * Creates a new supplier directly without an associated supplier request. Returns 409 if a supplier with the same email already exists.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSupplierV1Integration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSupplierV1Integration(params: {

    /**
     * Supplier data to create
     */
    body: SupplierCreateCommandV1
  },
  context?: HttpContext

): Observable<SupplierIntegrationQueryV1> {

    return this.createSupplierV1Integration$Response(params,context).pipe(
      map((r: StrictHttpResponse<SupplierIntegrationQueryV1>) => r.body as SupplierIntegrationQueryV1)
    );
  }

  /**
   * Path part for operation deactivateSupplierIntegrationV1
   */
  static readonly DeactivateSupplierIntegrationV1Path = '/v1/integration/suppliers/{supplierId}/deactivate';

  /**
   * Deactivate a supplier via integration API.
   *
   * Deactivates a supplier and all associated supplier users. Idempotent: returns success if supplier is already deactivated.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deactivateSupplierIntegrationV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateSupplierIntegrationV1$Response(params: {
    supplierId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SupplierIntegrationQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, V1SupplierIntegrationService.DeactivateSupplierIntegrationV1Path, 'post');
    if (params) {
      rb.path('supplierId', params.supplierId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SupplierIntegrationQueryV1>;
      })
    );
  }

  /**
   * Deactivate a supplier via integration API.
   *
   * Deactivates a supplier and all associated supplier users. Idempotent: returns success if supplier is already deactivated.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deactivateSupplierIntegrationV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateSupplierIntegrationV1(params: {
    supplierId: string;
  },
  context?: HttpContext

): Observable<SupplierIntegrationQueryV1> {

    return this.deactivateSupplierIntegrationV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<SupplierIntegrationQueryV1>) => r.body as SupplierIntegrationQueryV1)
    );
  }

  /**
   * Path part for operation activateSupplierIntegrationV1
   */
  static readonly ActivateSupplierIntegrationV1Path = '/v1/integration/suppliers/{supplierId}/activate';

  /**
   * Activate a previously deactivated supplier via integration API.
   *
   * Activates a previously deactivated supplier. Does not automatically reactivate supplier users. Idempotent: returns success if supplier is already active.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activateSupplierIntegrationV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateSupplierIntegrationV1$Response(params: {
    supplierId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SupplierIntegrationQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, V1SupplierIntegrationService.ActivateSupplierIntegrationV1Path, 'post');
    if (params) {
      rb.path('supplierId', params.supplierId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SupplierIntegrationQueryV1>;
      })
    );
  }

  /**
   * Activate a previously deactivated supplier via integration API.
   *
   * Activates a previously deactivated supplier. Does not automatically reactivate supplier users. Idempotent: returns success if supplier is already active.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `activateSupplierIntegrationV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateSupplierIntegrationV1(params: {
    supplierId: string;
  },
  context?: HttpContext

): Observable<SupplierIntegrationQueryV1> {

    return this.activateSupplierIntegrationV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<SupplierIntegrationQueryV1>) => r.body as SupplierIntegrationQueryV1)
    );
  }

  /**
   * Path part for operation listSuppliersV1Integration
   */
  static readonly ListSuppliersV1IntegrationPath = '/v1/integration/suppliers/list';

  /**
   * List suppliers for integration using cursor-based pagination.
   *
   * Retrieves suppliers for ERP consumption using continuation token pagination. Supports filtering by id, supplierName, email, organizationsIds, active, and supplierNumber. Maximum page size is 200. Default sort is createdDate DESC.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSuppliersV1Integration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listSuppliersV1Integration$Response(params: {

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CursorPaginatedResponseSupplierIntegrationQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, V1SupplierIntegrationService.ListSuppliersV1IntegrationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CursorPaginatedResponseSupplierIntegrationQueryV1>;
      })
    );
  }

  /**
   * List suppliers for integration using cursor-based pagination.
   *
   * Retrieves suppliers for ERP consumption using continuation token pagination. Supports filtering by id, supplierName, email, organizationsIds, active, and supplierNumber. Maximum page size is 200. Default sort is createdDate DESC.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSuppliersV1Integration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listSuppliersV1Integration(params: {

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<CursorPaginatedResponseSupplierIntegrationQueryV1> {

    return this.listSuppliersV1Integration$Response(params,context).pipe(
      map((r: StrictHttpResponse<CursorPaginatedResponseSupplierIntegrationQueryV1>) => r.body as CursorPaginatedResponseSupplierIntegrationQueryV1)
    );
  }

  /**
   * Path part for operation assignSupplierNumberV1
   */
  static readonly AssignSupplierNumberV1Path = '/v1/integration/suppliers/{supplierId}/supplier-number';

  /**
   * Assign ERP Supplier Number to a supplier.
   *
   * Assigns an ERP supplier number to the specified supplier. Returns 409 if the ERP number is already assigned to a different supplier. Idempotent: returns success if the same supplier already has this number.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignSupplierNumberV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignSupplierNumberV1$Response(params: {
    supplierId: string;

    /**
     * ERP supplier number to assign
     */
    body: SupplierNumberCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SupplierIntegrationQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, V1SupplierIntegrationService.AssignSupplierNumberV1Path, 'patch');
    if (params) {
      rb.path('supplierId', params.supplierId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SupplierIntegrationQueryV1>;
      })
    );
  }

  /**
   * Assign ERP Supplier Number to a supplier.
   *
   * Assigns an ERP supplier number to the specified supplier. Returns 409 if the ERP number is already assigned to a different supplier. Idempotent: returns success if the same supplier already has this number.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignSupplierNumberV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignSupplierNumberV1(params: {
    supplierId: string;

    /**
     * ERP supplier number to assign
     */
    body: SupplierNumberCommandV1
  },
  context?: HttpContext

): Observable<SupplierIntegrationQueryV1> {

    return this.assignSupplierNumberV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<SupplierIntegrationQueryV1>) => r.body as SupplierIntegrationQueryV1)
    );
  }

}
